<template lang="pug">
modal#delete-developer-client-modal(
  :close-button-label='$t("modal.publishApplication.closeButtonLabel")'
  :loading='loading'
  :process-button-label='$t("modal.publishApplication.processButtonLabel")'
  :title='$t("modal.publishApplication.title")'
  @process='publish'
  ref='modal'
)
  .text-center
    p.text-start {{ $t('modal.publishApplication.message') }}

    img.mt-4.mb-3(
      alt='developer-delete-warning'
      src='/img/ilustrations/publish-application.svg'
    )
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import OauthService from '@/services/Oauth';
import alert from '@/modules/account/common/alert';

export default {
  name: 'PublishApplicationModal',
  props: {
    clientId: [Number, String],
  },
  components: {
    Modal,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    publish() {
      this.loading = true;
      OauthService.deploy(this.clientId)
        .then(() => {
          this.listClients();
          alert.fireAlert(this.$t('modal.publishApplication.successMessage'), {
            classes: 'alert-success',
            styles:
              'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
            icon: 'circle-check',
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$refs.modal.close();
          this.$emit('refresh');
        });
    },
  },
};
</script>
